/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export interface LoyaltyAccountInfoVO {
  /**
   * account balance
   */
  accountBalance?: number;
  /**
   * Loyalty airline code
   */
  loyaltyAirlineCode?: string;
  /**
   * Frequent flyer number of customer
   */
  loyaltyNumber?: string;
  /**
   * Frequent flyer status of customer
   */
  loyaltyTierLevel?: string;
  /**
   * PayWithMile eligibility indicator
   */
  payWithMilesEligibilityInd?: string;
}
